import React from "react";
import { Box, IconButton } from "@mui/material";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";

const AddButtonWithLines = ({ onAdd, sx = {} }) => {
    const handleAdd = () => {
        if (onAdd) {
            onAdd();
        }
    };
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                width: "100%",
                cursor: "pointer",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "47%",
                    left: 0,
                    right: 0,
                    height: "1px",
                    backgroundColor: "#008AD8",
                    transform: "translateY(-50%)",
                },
                "&::after": {
                    content: '""',
                    position: "absolute",
                    top: "47%",
                    left: 0,
                    right: 0,
                    height: "1px",
                    backgroundColor: "#008AD8",
                    transform: "translateY(-50%)",
                    marginTop: "3px",
                },
                ...sx,
            }}
            onClick={handleAdd}
        >
            <IconButton
                sx={{
                    width: "22px",
                    background: "#fff",
                    zIndex: 2,
                    "&:hover": {
                        background: "#fff",
                        zIndex: 2,
                    },
                }}
            >
                <AddCircleOutline sx={{ fontSize: "22px", color: "#008AD8" }} />
            </IconButton>
        </Box>
    );
};

export default AddButtonWithLines;
